export enum NewLongSteelOrdersOnboardingTypes {
  START = 'NEW_LONGSTEEL_ORDERS_ONBOARDING/START',
  NEXT_STEP = 'NEW_LONGSTEEL_ORDERS_ONBOARDING/NEXT_STEP',
  FINISHED = 'NEW_LONGSTEEL_ORDERS_ONBOARDING/FINISHED'
}

export enum NewLongSteelOrdersOnboardingSteps {
  INITIAL = 'NEW_LONGSTEEL_ORDERS_ONBOARDING/INITIAL',
  NEXT_STEP = 'NEW_LONGSTEEL_ORDERS_ONBOARDING/NEXT_STEP',
  FINISHED = 'NEW_LONGSTEEL_ORDERS_ONBOARDING/FINISHED'
}

export interface NewLongSteelOrdersOnboardingState {
  loading: boolean;

  error: boolean;

  step: NewLongSteelOrdersOnboardingSteps;
}
